import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const SiteContext = createContext({ navigation: null, design: null, globals: null, loaded: false });

export const applyDesignTokens = (design) => {
  if (!design) return;
  const r = document.documentElement.style;
  const c = design.colors || {};
  const f = design.fonts || {};
  if (c.accent) r.setProperty('--site-accent', c.accent);
  if (c.accent_light) r.setProperty('--site-accent-light', c.accent_light);
  if (c.dark) r.setProperty('--site-dark', c.dark);
  if (c.surface) r.setProperty('--site-surface', c.surface);
  if (c.text) r.setProperty('--site-text', c.text);
  if (c.muted) r.setProperty('--site-muted', c.muted);
  if (f.heading) r.setProperty('--site-font-heading', `'${f.heading}', Georgia, serif`);
  if (f.body) r.setProperty('--site-font-body', `'${f.body}', system-ui, sans-serif`);
  if (design.radius) r.setProperty('--site-radius', design.radius);
  if (design.container_width) r.setProperty('--site-container', design.container_width);
  const shape = design.buttons?.shape;
  r.setProperty('--site-btn-radius', shape === 'pill' ? '9999px' : shape === 'rounded' ? '8px' : '0px');
};

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState({ navigation: null, design: null, globals: null, loaded: false });

  useEffect(() => {
    axios.get(`${API_URL}/website/site`)
      .then((res) => {
        applyDesignTokens(res.data.design);
        setSite({ ...res.data, builderPaths: res.data.builder_paths || [], loaded: true });
      })
      .catch(() => setSite((s) => ({ ...s, loaded: true })));
  }, []);

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
